import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const ok = params.get("durum") === "basarili";
  const orderNumber = params.get("siparis") || "";

  return (
    <div className="min-h-screen bg-atelier flex items-center justify-center p-4">
      <div
        className="card-atelier rounded-3xl p-10 max-w-md w-full text-center"
        data-testid={ok ? "payment-result-success" : "payment-result-fail"}
      >
        {ok ? (
          <>
            <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-5">
              <CheckCircle2 className="w-9 h-9 text-emerald-600" />
            </div>
            <h1 className="font-serif text-3xl mb-2">Ödemeniz Alındı</h1>
            <p className="text-stone-600 text-sm mb-1">
              Siparişiniz başarıyla oluşturuldu ve atölyemize iletildi.
            </p>
            {orderNumber && (
              <p className="text-sm mb-6">
                Sipariş No: <span className="font-semibold text-primary" data-testid="payment-result-order-number">{orderNumber}</span>
              </p>
            )}
            <div className="flex flex-col gap-2">
              <Link to="/siparislerim">
                <Button className="w-full rounded-full" data-testid="payment-result-orders-btn">
                  Siparişlerimi Gör
                </Button>
              </Link>
              <Link to="/tasarim">
                <Button variant="outline" className="w-full rounded-full" data-testid="payment-result-new-design-btn">
                  Yeni Tasarım Oluştur
                </Button>
              </Link>
            </div>
          </>
        ) : (
          <>
            <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-5">
              <XCircle className="w-9 h-9 text-red-600" />
            </div>
            <h1 className="font-serif text-3xl mb-2">Ödeme Tamamlanamadı</h1>
            <p className="text-stone-600 text-sm mb-1">
              Ödemeniz alınamadı veya iptal edildi. Kartınızdan tahsilat yapılmadı.
            </p>
            {orderNumber && (
              <p className="text-sm mb-6">
                Sipariş No: <span className="font-semibold text-primary" data-testid="payment-result-order-number">{orderNumber}</span>
              </p>
            )}
            <div className="flex flex-col gap-2">
              <Link to="/tasarim">
                <Button className="w-full rounded-full" data-testid="payment-result-retry-btn">
                  Tasarıma Dön ve Tekrar Dene
                </Button>
              </Link>
              <Link to="/siparislerim">
                <Button variant="outline" className="w-full rounded-full" data-testid="payment-result-orders-btn">
                  Siparişlerim
                </Button>
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
